export default {
  // pdf 尺度
  pdfScale: { type: [Number, String] },
  // 缩放倍数最小值
  zoomMin: { type: Number, default: 0.5 },
  // 缩放倍数最大值
  zoomMax: { type: Number, default: 3.5 },
  //
  transfer: { type: Boolean, default: true },
  domTransfer: { type: String, default: '#routerView' },
  // 列表模式
  listType: {
    type: Boolean,
    default: false,
  },
}
